import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menuList: JSON.parse(localStorage.getItem('menuList')),
    menuParent: JSON.parse(localStorage.getItem('menuParent')),
    menuChild: JSON.parse(localStorage.getItem('menuChild'))
  },

  // 更改 Vuex 的store 中的状态的唯一方法，并且它会接受 state 作为第一个参数，要调用 mutations 中的方法且必须同步执行，需要使用 store.commit 方法调用。
  mutations: {
    // 设置菜单
    SET_MENU(state, list) {
      state.menuList = list
      localStorage.setItem('menuList', JSON.stringify(list))
    },
    // 设置父级菜单
    SET_PARENT(state, par) {
      state.menuParent = par
      localStorage.setItem('menuParent', JSON.stringify(par))
    },
    // 设置子集
    SET_CHILD(state, child) {
      state.menuChild = child
      localStorage.setItem('menuChild', JSON.stringify(child))
    }
  },

  // action 写法与 mutations一样，但是 action 中是执行 mutations 中的方法，而不是直接改变期状态 state，且可以不受同步执行的限制，在 actions 中可以进行异步执行的操作
  actions: {
    // 进行页面跳转
    navigateTo({ state, commit }, { $router, parent, child }) {
      if (child) {
        commit('SET_PARENT', parent)
        commit('SET_CHILD', child)
        $router.push({ path: state.menuChild.url })
      } else {
        commit('SET_PARENT', parent)
        state.menuChild && localStorage.removeItem('menuChild')
        commit('SET_CHILD', null)
        $router.push({ path: state.menuParent.url })
      }
    }
  },
  modules: {}
})
